import React from 'react';
import {render} from 'react-dom';

import AppComponent from 'iss/AppComponent';

render(<AppComponent />, document.getElementById('content'));



// WEBPACK FOOTER //
// ./modules/issFrontend/app.jsx